import React, { useState } from 'react';
import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  HStack,
  Text,
  VStack,
  Image,
} from '@chakra-ui/react';
import UserCreateForm from './user_forms/user_create_form';
import PanelCreateForm from './panel_forms/panel_create_form';
import RoleCreateForm from './role_forms/role_create_form';
import {
  createPanel,
  createUser,
  createRole,
  addPanelToUser,
} from '../store/api_funcs';
import { useStores } from '../store/store_context';
import { useToast } from '@chakra-ui/react';
import UserModal from './user_modal';
import UserEditForm from './user_forms/user_edit_form';
import UsersSearch from './users_autocomplete';
import PanelsSearch from './panels_autocomplete';
import { updateUserById } from '../store/api_funcs';
import logovas from './../assets/images/logovas.png';
import { useNavigate } from 'react-router';

const AdminHeaderButtons = ({
  updateUsersTable,
  updatePanelsTable,
  updateRolesTable,
  usersForPanelForm,
  rolesForUserFrom,
  changeTab,
  panels,
}) => {
  const [isOpenModal1, setIsOpenModal1] = useState(false);
  const [isOpenModal2, setIsOpenModal2] = useState(false);
  const [isOpenModal3, setIsOpenModal3] = useState(false);
  const [isOpenModal4, setIsOpenModal4] = useState(false);
  const [panelId, setPanelId] = useState(0);
  const [userId, setUserId] = useState(0);
  const toast = useToast();
  const { pageStore } = useStores();
  const navigate = useNavigate();

  const handleOpenModal1 = () => {
    setIsOpenModal1(true);
  };

  const handleCloseModal1 = () => {
    setIsOpenModal1(false);
  };

  const handleOpenModal2 = () => {
    setIsOpenModal2(true);
  };

  const handleCloseModal2 = () => {
    setIsOpenModal2(false);
  };
  const handleOpenModal3 = () => {
    setIsOpenModal3(true);
  };

  const handleCloseModal3 = () => {
    setIsOpenModal3(false);
  };
  const handleOpenModal4 = () => {
    setIsOpenModal4(true);
  };

  const handleCloseModal4 = () => {
    setIsOpenModal4(false);
  };
  const user_null = {
    name: '',
    username: '',
    hashed_password: '',
    description: '',
    phone: '',
    role_id: 1,
    language: 'RU',
    customer_type: '',
    creator_username: pageStore.username,
  };
  const panel_null = {
    theme: '',
    adress: '',
    model_url: '',
    fabric_number: '',
    comment: '',
    dimensions: '',
  };
  const role_null = {
    role_name: '',
    see_all_panels: 0,
    add_panels: 0,
    update_firmware: 0,
    see_all_users: 0,
    add_users: 0,
    edit_themes: 0,
    get_errors: 0,
    add_roles: 0,
    only_myself: 0,
    only_my_panel: 0,
    analytics: 0,
    monitoring_view: 0,
    monitoring_control: 0,
    repair_console_access: 0,
    incidents_manage: 0,
    tickets_manage: 0,
    monitoring_settings: 0,
    remote_control_panel: 0,
  };
  const primaryButtonProps = {
    color: 'white',
    backgroundColor: '#8B5CF6',
    _hover: { backgroundColor: '#7C3AED' },
    borderRadius: '8px',
  };

  return (
    <HStack width={'100%'} justify={'space-between'}>
      <HStack align={'center'}>
        <Image src={logovas} />

        <UserModal myself={true}>
          <UserEditForm
            changeTab={changeTab}
            user_id={pageStore.user_id}
            onSubmit={updateUserById}
            updateUsersTable={updateUsersTable}
            rolesForUserForm={rolesForUserFrom}
            myself={true}
            getTablePanels={updatePanelsTable}
            panels={panels}
          />
        </UserModal>
        {/* <VscAccount color={'#4945FF'} size={35}/> */}
      </HStack>
      <HStack>
        {pageStore.add_panels ? (
          <Button
            onClick={handleOpenModal1}
            {...primaryButtonProps}
          >
            Добавить панель
          </Button>
        ) : null}
        {pageStore.add_users ? (
          <Button
            onClick={handleOpenModal2}
            {...primaryButtonProps}
          >
            Добавить пользователя
          </Button>
        ) : null}
        {pageStore.add_roles ? (
          <Button
            onClick={handleOpenModal3}
            {...primaryButtonProps}
          >
            Добавить роль
          </Button>
        ) : null}
        {pageStore.add_users && (
          <Button
            onClick={handleOpenModal4}
            {...primaryButtonProps}
          >
            Панель к пользователю
          </Button>
        )}
        <Button
          onClick={() => {
            navigate('/');
            pageStore.unlogin();
          }}
          color="white"
          backgroundColor={'rgba(139,92,246,0.72)'}
          _hover={{ backgroundColor: '#8B5CF6' }}
        >
          Выход
        </Button>
      </HStack>

      <Modal isOpen={isOpenModal1} onClose={handleCloseModal1}>
        <ModalOverlay />
        <ModalContent
          backgroundColor={'#1b1c2b'}
          color={'white'}
          fontFamily={"'Jura', sans-serif"}
        >
          <ModalHeader>Новая панель</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <PanelCreateForm
              initialValues={panel_null}
              onSubmit={createPanel}
              updatePanelsTable={updatePanelsTable}
              usersForPanelForm={usersForPanelForm}
              changeTab={changeTab}
            />
          </ModalBody>
          <ModalFooter>
            <Button
              onClick={handleCloseModal1}
              backgroundColor={'#8B5CF6'}
              _hover={{ backgroundColor: '#7C3AED' }}
              color="white"
            >
              Закрыть
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal isOpen={isOpenModal2} onClose={handleCloseModal2}>
        <ModalOverlay />
        <ModalContent
          fontFamily={"'Jura', sans-serif"}
          backgroundColor={'#1b1c2b'}
          color={'white'}
        >
          <ModalHeader>Новый пользователь</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <UserCreateForm
              initialValues={user_null}
              onSubmit={createUser}
              updateUsersTable={updateUsersTable}
              rolesForUserForm={rolesForUserFrom}
              changeTab={changeTab}
            />
          </ModalBody>
          <ModalFooter>
            <Button
              onClick={handleCloseModal2}
              backgroundColor={'#8B5CF6'}
              _hover={{ backgroundColor: '#7C3AED' }}
              color="white"
            >
              Закрыть
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <Modal isOpen={isOpenModal3} onClose={handleCloseModal3}>
        <ModalOverlay />
        <ModalContent
          fontFamily={"'Jura', sans-serif"}
          backgroundColor={'#1b1c2b'}
          color={'white'}
        >
          <ModalHeader>Новая роль</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <RoleCreateForm
              initialValues={role_null}
              onSubmit={createRole}
              updateRolesTable={updateRolesTable}
              changeTab={changeTab}
            />
          </ModalBody>
          <ModalFooter>
            <Button
              onClick={handleCloseModal3}
              backgroundColor={'#8B5CF6'}
              _hover={{ backgroundColor: '#7C3AED' }}
              color="white"
            >
              Закрыть
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <Modal isOpen={isOpenModal4} onClose={handleCloseModal4}>
        <ModalOverlay />
        <ModalContent
          backgroundColor={'#1b1c2b'}
          color={'white'}
          fontFamily={"'Jura', sans-serif"}
        >
          <ModalHeader>Назначить сотрудника к панели</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <VStack align={'flex-start'}>
              <Text fontSize={16} color={'gray'}>
                Чтобы назначить пользователя к панели начните печатать ее адрес
                или номер и выбрав панель нажмите кнопку добавить
              </Text>
              <Text fontSize={14} color={'gray'}>
                Выберите пользователя
              </Text>
              <UsersSearch
                items={
                  usersForPanelForm &&
                  usersForPanelForm.map(elem => {
                    return { id: elem.user_id, name: elem.username };
                  })
                }
                setResult={setUserId}
              />
              <Text fontSize={14} color={'gray'}>
                Выберите панель
              </Text>
              <PanelsSearch
                setResult={setPanelId}
                items={
                  panels &&
                  panels.map(elem => {
                    return {
                      id: elem.panel_id,
                      name: elem.adress,
                      number: elem.fabric_number,
                    };
                  })
                }
              />
              <Button
                backgroundColor={'#8B5CF6'}
                _hover={{ backgroundColor: '#7C3AED' }}
                color="white"
                onClick={async () => {
                  try {
                    await addPanelToUser(panelId, userId, pageStore.token);
                    toast({
                      title: 'Данные успешно сохранены.',
                      status: 'success',
                      duration: 3000,
                      isClosable: true,
                    });
                    await updatePanelsTable();
                  } catch (error) {
                    console.error('Ошибка при отправке данных:', error);
                    toast({
                      title: 'Ошибка',
                      description:
                        'Что-то пошло не так. Пожалуйста, попробуйте снова.',
                      status: 'error',
                      duration: 5000,
                      isClosable: true,
                    });
                  }
                }}
              >
                Добавить
              </Button>
            </VStack>
          </ModalBody>
          <ModalFooter>
            <Button
              onClick={handleCloseModal4}
              backgroundColor={'#8B5CF6'}
              _hover={{ backgroundColor: '#7C3AED' }}
              color="white"
            >
              Закрыть
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </HStack>
  );
};

export default AdminHeaderButtons;
